import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppConfigService, AppConfiguration } from 'src/app/core/service/app-config.service';
import { MemberService } from 'src/app/core/service/member.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  standalone: false,
  selector: 'app-member-send-selection',
  templateUrl: './member-send-selection.component.html',
  styleUrls: ['./member-send-selection.component.scss']
})
export class MemberSendSelectionComponent
{
  @Input() public type: string | 'CONSENT' | 'INVITE';
  @Input() public memberSelected: any;
  @Input() public open: boolean;

  @Output() public closing: EventEmitter<boolean> = new EventEmitter();

  public methodRequest: string;
  public sending = false;

  private appConfig: AppConfiguration;

  constructor(
    private memberService: MemberService,
    private messageHandlerService: MessageHandlerService,
    private appConfigService: AppConfigService
  )
  {
    this.appConfig = this.appConfigService.getConfig();
  }

  public send(): void
  {
    this.sending = true;
    const request = { memberId: this.memberSelected.id, type: this.methodRequest, baseUrl: this.appConfig.community.baseUrl };

    let methodName = '';
    let messageKey = '';

    switch (this.type)
    {
      case 'CONSENT':
        methodName = 'createConsent';
        messageKey = 'CONSENT-REQUESTED-SUCCESSFULLY';
        break;
      case 'INVITE':
        methodName = 'createInvite';
        messageKey = 'COMMUNITY-INVITE-SENT-SUCCESSFULLY';
        break;
    }

    this.memberService[methodName](request).subscribe({
      next: () =>
      {
        this.messageHandlerService.displaySuccess(messageKey);
        this.methodRequest = undefined;
        this.closing.emit(true);
      },
      error: (errorResponse: any) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      },
      complete: () =>
      {
        this.memberSelected = null;
        this.sending = false;
      }
    });
  }

  public close(): void
  {
    this.methodRequest = undefined;
    this.closing.emit(false);
  }
}
